import { useHistory } from "react-router-dom";
import { Button, Input, InputRef, Space } from "antd";
import { Box, FontFa, Table } from "../../../components";
import { withLandingProcedureWraper } from "../../procedure";
import { DateFormat, requestStatus } from "../../../constants";
import { approveProcess } from "../../procedure/human-organization/absence-letter/constants";
import { useStep } from "../../procedure/human-organization/absence-letter/hooks";
import { useLandingStatistic } from "../../procedure/dashboard/hooks/use-landing-statistic";
import { useMemo, useRef } from "react";
import { useSearchParams } from "../../../hook/use-search-params";
import { getListIdByFieldsContext, getProcessPathByListId } from "../../procedure/util";
import { FilterConfirmProps } from "antd/lib/table/interface";
import { ColumnType, ColumnsType } from "antd/es/table";
import { DateHelper } from "../../../helper";
import moment from "moment";
import CountPreview from "../CountPreview";

export const DetailRequestTable = withLandingProcedureWraper(() => {
  const {
    allRequests,
    getMyAllMyRequest,
    getMyAllStatusRequest,
    getMyApproveRequests,
    getMyExpiredRequests,
    isPin,
    isHaveAttachment,
    approveFinishRequests,
  } = useLandingStatistic();
  const { searchParams } = useSearchParams();

  const searchInput = useRef<InputRef>(null);

  const requests = useMemo(() => {
    switch (searchParams.get("requests")) {
      case "my":
        return getMyAllMyRequest(allRequests)
          .sort((a: any, b: any) => (moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? -1 : 1))
          .reverse();
      case "approve":
        return getMyApproveRequests(allRequests)[0].sort((a: any, b: any) =>
          moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? -1 : 1,
        );
      // .reverse();
      case "my-finished":
        return getMyAllStatusRequest(allRequests)[0]
          .sort((a: any, b: any) => (moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? -1 : 1))
          .reverse();
      case "my-waiting":
        return getMyAllStatusRequest(allRequests)[1].sort((a: any, b: any) =>
          moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? -1 : 1,
        );
      // .reverse();
      case "my-expired":
        return getMyExpiredRequests().sort((a: any, b: any) =>
          moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? -1 : 1,
        );
      // .reverse();
      case "approve-waiting":
        return getMyApproveRequests(allRequests)[0].sort((a: any, b: any) =>
          moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? -1 : 1,
        );
      // .reverse();
      case "approve-expired":
        return getMyApproveRequests(allRequests)[1].sort((a: any, b: any) =>
          moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? -1 : 1,
        );
      case "approve-finished":
        return approveFinishRequests.sort((a: any, b: any) =>
          moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? -1 : 1,
        );
      // .reverse();

      default:
        return allRequests;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allRequests, searchParams]);

  const history = useHistory();
  const { checkRequestStatus } = useStep();

  const handleSearch = (selectedKeys: string[], confirm: (param?: FilterConfirmProps) => void, dataIndex: any) => {
    confirm();
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
  };

  const getColumnSearchProps = (dataIndex: any, placeholder?: string): ColumnType<any> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
            icon={<FontFa name="faSearch" />}
            size="small"
            style={{ width: 90 }}
          >
            Tìm kiếm
          </Button>
          <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Đóng
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => <FontFa name="faSearch" size="1x" color="#333" />,
    onFilter: (value, record) =>
      record[dataIndex] &&
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center" as const,
      width: 80,
      sorter: (a: any, b: any) => a.index - b.index,
      sortDirections: ["descend", "ascend"],
      showSorterTooltip: { title: "Click vào để sắp xếp" },
    },
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: 120,
      sorter: (a: any, b: any) => a.id - b.id,
      sortDirections: ["descend", "ascend"],
      showSorterTooltip: { title: "Click vào để sắp xếp" },
    },
    {
      title: "Ngày tạo ",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      sorter: (a: any, b: any) =>
        moment(a.createdDateTime, DateFormat.DD_MM_YYY).isBefore(moment(b.createdDateTime, DateFormat.DD_MM_YYY))
          ? -1
          : 1,
      sortDirections: ["descend", "ascend"],
      showSorterTooltip: { title: "Click vào để sắp xếp" },
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      ...getColumnSearchProps("createdByName", "Nhập tên cần người cần tìm"),
    },
    {
      title: "Nội dung yêu cầu",
      dataIndex: "Title",
      key: "Title",
      ...getColumnSearchProps("Title", "Nhập nội dung cần tìm"),
    },
    {
      title: "Mô tả",
      dataIndex: "eDescription",
      key: "eDescription",
      ...getColumnSearchProps("eDescription", "Nhập mô tả cần tìm"),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => {
        if (record.eRequestStatus === requestStatus.completed) {
          return <div className="flag success">Đã hoàn tất</div>;
        }
        if (record.eRequestStatus === requestStatus.rejected) {
          return <div className="flag danger">Đã từ chối</div>;
        }
        if (checkRequestStatus(approveProcess, record) === requestStatus.approved) {
          return <div className="flag success">Đã duyệt</div>;
        }
        return <div className="flag warning">Đang đợi duyệt</div>;
      },
      filters: [
        {
          text: "Đang đợi duyệt",
          value:
            requestStatus.submitted +
            "|" +
            requestStatus.acceptance +
            "|" +
            requestStatus.inProgress +
            "|" +
            requestStatus.preApproved,
        },
        {
          text: "Đã hoàn tất",
          value: requestStatus.completed + "|" + requestStatus.approved,
        },
        {
          text: "Đã từ chối",
          value: requestStatus.rejected,
        },
      ],
      onFilter: (value, record) => {
        const arrSplit = (value as string).split("|");
        const index = arrSplit.findIndex((e: any) => e === record.eRequestStatus);
        return index > -1;
      },
      filterSearch: true,
      ellipsis: true,
    },
    {
      title: "",
      dataIndex: "isAttachment",
      key: "isAttachment",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <div>
          <p style={{ paddingLeft: "12px" }}>
            <span style={{ paddingRight: "5px" }}>
              <FontFa name="faThumbtack" color={record.isPin ? "#be3a3d" : undefined} />
            </span>
            <span>{record.isAttachment && <FontFa name="faPaperclip" color="#be3a3d" />}</span>
          </p>
        </div>
      ),
    },
  ];

  const dataSource = requests.map((item: any, index: number) => {
    const { eContent, ...restFields } = item.fields;
    return {
      index: index + 1,
      eTag: item.eTag,
      id: item.id,
      ...restFields,
      "fields@odata.context": item["fields@odata.context"],
      createdByName: item.createdBy.user.displayName,
      createdDateTime: DateHelper.formatDateToString(item.createdDateTime),
      isPin: isPin(item),
      isAttachment: isHaveAttachment(item),
    };
  });

  const sortedDataSources = dataSource.sort((requestA: any, requestB: any) => {
    // First, calculate the isPin value for each request
    const isPinA = requestA.isPin;
    const isPinB = requestB.isPin;

    // Compare the isPin values for sorting
    if (isPinA && !isPinB) {
      return -1; // requestA comes before requestB
    } else if (!isPinA && isPinB) {
      return 1; // requestB comes before requestA
    } else {
      return 0; // leave the order as it is
    }
  });

  return (
    <div className="ITCodeGrantedPage">
      <div className="px-3 pt-2">
        <CountPreview />
      </div>
      <div className="pd15">
        <div className="text-md-left font-weight-normal p-3 bg-info text-white" style={{ fontSize: "14px" }}>
          <div className="row title__process-container">
            <div className="">
              <span className="icon__title-process">{"📋  "}</span>
              Chi tiết yêu cầu
            </div>
          </div>
        </div>
      </div>
      <Box
        title={
          searchParams.get("requests")?.includes("my")
            ? "Yêu cầu của tôi"
            : searchParams.get("requests")?.includes("finished")
            ? "Yêu cầu xử lý đã hoàn tất"
            : "Yêu cầu cần xử lý"
        }
        className="mx-3 mb-2"
      >
        <Table
          rowKey="eTag"
          // loading={isLoading}
          columns={columns}
          dataSource={sortedDataSources}
          onRow={(record) => ({
            onClick: () =>
              history.push(
                getProcessPathByListId(getListIdByFieldsContext(record["fields@odata.context"])).replace(
                  ":id",
                  record.id,
                ),
              ),
            style: { cursor: "pointer" },
          })}
        />
      </Box>
    </div>
  );
});
